import React, { useState, useEffect } from "react";
import axios from "axios";
import { Monitor } from "lucide-react";
import { NGROK } from "../../../../APIs";
import SelectionFeedback from "./SelectionFeedback";

const DeviceSelection = ({
  os,
  setActiveDevicesList,
  activeDevicesList,
  selectedTenant,
}) => {
  const [devicesList, setDevicesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(false);
    const getDevices = async () => {
      try {
        const response = await axios.get(
          `${NGROK}/api/${selectedTenant.tenantName}/computers`,
        );
        const devices =
          response.data && response.data.length
            ? response.data.filter((device) =>
                device.OperatingSystem.toLowerCase().includes(os.toLowerCase()),
              )
            : [];
        if (mounted) setDevicesList(devices);
      } catch (error) {
        console.error(error);
        if (mounted) {
          setDevicesList([]);
          setError(true);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (selectedTenant) getDevices();
    else setLoading(false);
    return () => {
      mounted = false;
    };
  }, [os, selectedTenant]);

  if (loading || error || !devicesList.length)
    return (
      <SelectionFeedback
        loading={loading}
        error={error}
        title={error ? "Unable to load devices" : "No matching devices"}
        description={
          error
            ? "Go back and select the operating system again to retry."
            : "No devices are available for this operating system. Go back to choose another system or tenant."
        }
      />
    );

  return (
    <div className="op-choice-grid">
      {devicesList.map((device) => {
        const selected = activeDevicesList.some(
          (item) => item.id === device.id,
        );
        return (
          <label
            key={device.id}
            className={`op-choice ${selected ? "is-selected" : ""}`}
          >
            <input
              type="checkbox"
              checked={selected}
              onChange={() =>
                setActiveDevicesList((previous) =>
                  selected
                    ? previous.filter((item) => item.id !== device.id)
                    : [...previous, device],
                )
              }
            />
            <Monitor aria-hidden="true" />
            <span>
              <strong>{device.dNSHostName}</strong>
              <small>{device.OperatingSystem}</small>
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default DeviceSelection;
